import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxStarIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M21.7016 9.64646C21.5248 9.09126 20.9944 8.53046 20.2072 8.53046H15.0424L13.4616 3.67686C13.252 3.02486 12.6696 2.60486 11.9784 2.60486C11.2864 2.60486 10.704 3.02566 10.4952 3.67686L8.91359 8.54966H3.74959C3.04959 8.54966 2.50319 8.93446 2.28959 9.58006C2.10799 10.1289 2.20399 10.8905 2.82879 11.3553L2.83599 11.3609L7.00959 14.3737L5.41759 19.2113C5.15279 19.9633 5.51279 20.6369 5.98719 20.9705C6.44399 21.2921 7.18399 21.4129 7.80559 20.9569L11.9792 17.9441L16.1496 20.9377C16.8184 21.4281 17.5264 21.2641 17.9664 20.9481C18.5256 20.5465 18.7528 19.8665 18.5464 19.2161L18.5448 19.2097L16.9472 14.3537L21.1088 11.3497C21.6896 10.9377 21.9112 10.3009 21.7024 9.64486L21.7016 9.64646ZM20.556 10.5785L15.828 13.9913L17.6416 19.5025C17.7224 19.7569 17.6336 20.0201 17.416 20.1753C17.1992 20.3297 16.9232 20.3273 16.7104 20.1705L11.9792 16.7745L7.24639 20.1905C7.14079 20.2689 7.01599 20.3081 6.89039 20.3081C6.76079 20.3081 6.63039 20.2665 6.51919 20.1825C6.30639 20.0233 6.22799 19.7625 6.31679 19.5169L8.12959 14.0097L3.39919 10.5953C3.18159 10.4337 3.09759 10.1649 3.18239 9.90966C3.26559 9.66006 3.48799 9.49846 3.75039 9.49846H9.60399L11.3992 3.96726C11.4792 3.71686 11.7064 3.55366 11.9784 3.55366C12.2504 3.55366 12.4784 3.71606 12.5584 3.96806L14.3528 9.47926H20.2072C20.4736 9.47926 20.7064 9.65046 20.7864 9.90486C20.8664 10.1593 20.776 10.4233 20.5552 10.5777L20.556 10.5785Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
